import React from "react";
import DetailsTab from "./DetailsTab";
import AttendanceTab from "./AttendanceTab";
import SyllabusTab from "./SyllabusTab";
import ChannelsPostHome from "Pages/MyBatches/Channels/ChannelsPostHome";
import { LectureData } from "./LectureTypes";

interface LectureTabsProps {
  activeTab: string;
  lecture: LectureData;
  batchDetailsData: any;
}

const LectureTabs: React.FC<LectureTabsProps> = ({
  activeTab,
  lecture,
  batchDetailsData,
}) => {
  return (
    <>
      {/* DETAILS TAB */}
      {activeTab === "details" && <DetailsTab lecture={lecture} />}

      {/* ATTENDANCE TAB */}
      {activeTab === "attendance" && <AttendanceTab lecture={lecture} />}

      {/* SYLLABUS TAB */}
      {activeTab === "syllabus" && <SyllabusTab lecture={lecture} />}

      {/* CHANNELS TAB */}
      {activeTab === "channels" && (
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
            minHeight: "500px",
          }}
        >
          <style>{`
            .ant-tabs-tab[data-node-key="POST"] .ant-tabs-tab-btn {
              color: var(--primary-text) !important;
            }
          `}</style>
          <ChannelsPostHome
            batchDetailsData={batchDetailsData}
            batchId={lecture?.batchId}
          />
        </div>
      )}
    </>
  );
};

export default LectureTabs;
